import React from "react";
import { Link } from "react-router-dom";
import ConsultationForm from "../../pages/Web_Design/Consulation_form";
import ConsultationAreaForm from "../Consultation/ConsultationAreaForm";

const BannerOne = () => {
  return (
    <section className="banner-area banner-bg">
      <div className="container">
        <div className="row align-items-center" style={{gap: "3rem"}}>
          <div className="col-lg-5">
            <div className="banner-img wow fadeInLeft" data-wow-delay=".4s">
              {/* <img alt="banner-image" src="/img/custom-imgs/banner.webp"  /> */}
              <ConsultationAreaForm />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner-content">
              <span className="sub-title wow fadeInUp" data-wow-delay=".2s">
                Amazing <strong>Starts</strong> Here
              </span>
              <h1 className="title wow fadeInUp" data-wow-delay=".4s" style={{marginBottom: "12px"}}>
              Graphic Design <span className="design-style">Agency</span> in Hobart, TAS 
              </h1>
              <p>Innovatix Hub, AU of digital mastery, where innovation meets creation. </p>
              {/* <Link
                to="/contact"
                className="btn wow fadeInUp"
                data-wow-delay=".6s"
              >
                Contact Us <span></span>
              </Link> */}
            </div>
          </div>
        </div>
      </div>
      <div className="banner-shape-wrap">
        <img alt="banner-image" src="/img/banner/banner_shape01.webp"  />
        <img alt="banner-image"
          src="/img/banner/banner_shape02.webp"
          
          className="animationFramesOne"
        />
        <img alt="banner-image"
          src="/img/banner/banner_shape03.webp"
          
          className="ribbonRotate"
        />
        <img alt="banner-image" src="/img/banner/banner_shape04.webp"  className="rotateme" />
        <img alt="banner-image"
          src="/img/banner/banner_shape05.webp"
          
          className="animation1"
        />
        <img alt="banner-image"
          src="/img/banner/banner_shape06.webp"
          
          className="contactSwimmer"
        />
        <img alt="banner-image"
          src="/img/banner/banner_shape07.webp"
          
          className="float-bob-x"
        />
      </div>
    </section>
  );
};

export default BannerOne;
